<template>
  <div>
    <PageTitle
    :main="$t('cadastro-de-processos')"
    sub=""
    imagem="dashboard.png"
    />
    <GridProcess></GridProcess>
  </div>
</template>

<script>
import PageTitle from '../template/PageTitle.vue';
import GridProcess from './GridProcess.vue';

export default {
  name:"Process",
  components: { GridProcess, PageTitle }
}
</script>

<style scoped>

</style>